export const downloadReducer = (state = { content: [], loading: true, dataLoaded: false }, action) => {
    switch (action.type) {
      case 'DOWNLOAD_REQUEST':
        return { ...state, loading: true };
      case 'DOWNLOAD_SUCCESS':
        return { 
          ...state, 
          loading: false, 
          content: action.payload,
          dataLoaded: true
        };
      case 'DOWNLOAD_FAIL':
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  